import { render, staticRenderFns } from "./GenericNameLabel.vue?vue&type=template&id=25dcbd38&scoped=true"
import script from "./GenericNameLabel.vue?vue&type=script&lang=js"
export * from "./GenericNameLabel.vue?vue&type=script&lang=js"
import style0 from "./GenericNameLabel.vue?vue&type=style&index=0&id=25dcbd38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dcbd38",
  null
  
)

export default component.exports